import { useEffect, useState, useCallback } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { PageUrl, SessionKey } from '../../utils/app-config';
import { useApiService } from '../../services';
import Loader from "../../components/molecules/Loader";

const SecureRoute = ({ children }: { children: JSX.Element }) => {
  const location = useLocation();
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
  const { ValidateToken } = useApiService();

  // Cache token on mount
  const authToken = localStorage.getItem(SessionKey.AuthToken) ?? '';

  const fetchTokenData = useCallback(async () => {
    if (!authToken) {
      setIsAuthenticated(false);
      return;
    }

    try {
      const status = await ValidateToken({ token: authToken });
      setIsAuthenticated(status === true);
      if (status === false) {
        localStorage.clear();
      }
    } catch (error) {
      // Handle validation error as unauthorized
      localStorage.clear();
      setIsAuthenticated(false);
    }
  }, [authToken, ValidateToken]);

  useEffect(() => {
    fetchTokenData();
  }, [fetchTokenData]);

  if (isAuthenticated === null) {
    // Optionally show a spinner or placeholder while verifying
    return <Loader />;
  }

  if (isAuthenticated === false) {
    return <Navigate to={PageUrl.Login} state={{ from: location }} replace />;
  }

  return children;
};

export default SecureRoute;
